exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 768px){\n.row{\n    display:flex !important;\n    flex-flow:column wrap !important;\n}\n}\n\n\n", ""]);

// exports
